var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.998,
    viewBox: "0 0 20 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-send",
    "data-name": "Icon ionic-ios-send",
    d: "M23.872,4.548,4.751,12.882a.438.438,0,0,0,.016.8L9.939,16.6a.834.834,0,0,0,.953-.094l10.2-8.792c.068-.057.229-.167.292-.1s-.036.224-.094.292L12.465,17.84a.831.831,0,0,0-.083.995l3.381,5.422a.44.44,0,0,0,.792-.01L24.461,5.126A.438.438,0,0,0,23.872,4.548Z",
    transform: "translate(-4.503 -4.503)",
    fill: "#fbfbfb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendWhite);
export default __webpack_public_path__ + "static/media/send_white.12f70f8257ab8d2b0a3df037e6d79e8c.svg";
export { ForwardRef as ReactComponent };